import React, { useState } from "react";
import { toast } from "sonner";
import { subscribeNewsletter, extractErrorMessage } from "@/lib/api";
import { NEWSLETTER } from "@/constants/testIds";
import Reveal from "./Reveal";

export default function NewsletterCapture({ source = "home", tone = "light" }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [errorMsg, setErrorMsg] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus("loading");
    setErrorMsg("");
    try {
      await subscribeNewsletter({ email, source });
      setStatus("success");
      toast.success("You are on the list.");
      setEmail("");
    } catch (err) {
      setStatus("error");
      const msg = extractErrorMessage(err);
      setErrorMsg(msg);
      toast.error(msg);
    }
  };

  const isDark = tone === "dark";
  return (
    <div className="rk-container-text">
      <Reveal>
        <div
          className="rk-eyebrow"
          style={{ color: isDark ? "rgba(250,247,242,0.6)" : undefined }}
        >
          Newsletter — Bi-weekly
        </div>
      </Reveal>
      <Reveal delay={0.05}>
        <h3
          className="rk-heading-section mt-5"
          style={{ color: isDark ? "var(--rk-cream)" : undefined }}
        >
          The Architecture Letter.
        </h3>
      </Reveal>
      <Reveal delay={0.1}>
        <p
          className="mt-6 rk-body"
          style={{
            color: isDark ? "rgba(250,247,242,0.8)" : "var(--rk-ink)",
            maxWidth: 620,
          }}
        >
          A bi-weekly dispatch for founders and operators — on the decisions
          that determine whether your technology scales. Written personally by
          Rakia Finley. No motivational preamble. No recycled frameworks.
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <form
          onSubmit={onSubmit}
          className="mt-8 flex flex-col sm:flex-row gap-3 sm:gap-3 sm:items-center max-w-[560px]"
          noValidate
        >
          <label htmlFor="newsletter-email" className="sr-only">
            Email
          </label>
          <input
            id="newsletter-email"
            type="email"
            required
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@company.com"
            data-testid={NEWSLETTER.emailInput}
            className="rk-field flex-1"
            style={
              isDark
                ? {
                    backgroundColor: "transparent",
                    color: "var(--rk-cream)",
                    borderColor: "rgba(250,247,242,0.3)",
                  }
                : {}
            }
          />
          <button
            type="submit"
            disabled={status === "loading"}
            data-testid={NEWSLETTER.submit}
            className="rk-btn-primary"
          >
            {status === "loading" ? "Subscribing…" : "Subscribe"}
          </button>
        </form>
      </Reveal>
      {status === "success" && (
        <div
          data-testid={NEWSLETTER.success}
          className="mt-5"
          style={{
            display: "inline-block",
            paddingTop: 14,
            borderTop: "1px solid var(--rk-copper)",
            color: isDark ? "var(--rk-cream)" : "var(--rk-ink)",
            fontSize: 15,
          }}
        >
          You are on the list. First issue coming soon.
        </div>
      )}
      {status === "error" && (
        <div
          data-testid={NEWSLETTER.error}
          className="mt-5"
          style={{ color: "var(--rk-danger)", fontSize: 14 }}
        >
          {errorMsg}
        </div>
      )}
      <p
        className="mt-5 rk-caption"
        style={{ color: isDark ? "rgba(250,247,242,0.55)" : undefined }}
      >
        First issue coming soon. Unsubscribe in one click.
      </p>
    </div>
  );
}
